// eslint-disable-next-line import/no-deprecated
import createChainOfResponsibilityForFluentUI from './createChainOfResponsibilityForFluentUI.tsx';

// eslint-disable-next-line import/no-deprecated
export { createChainOfResponsibilityForFluentUI };
